export default __webpack_public_path__ + "static/media/huiqiao.0046bcf6.png";